import * as React from 'react'
import {
  Card as DSCard,
  CardHeader as DSCardHeader,
  CardContent as DSCardContent,
  CardFooter as DSCardFooter,
  CardTitle,
  CardDescription,
  type CardProps as DSCardProps,
} from 'uyari-design-system'
import { cn } from '@/lib/utils'

const Card = React.forwardRef<HTMLDivElement, DSCardProps>(({ className, ...props }, ref) => (
  <DSCard ref={ref} padding="none" className={cn('shadow-sm', className)} {...props} />
))
Card.displayName = 'Card'

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <DSCardHeader ref={ref} className={cn('p-6', className)} {...props} />
  )
)
CardHeader.displayName = 'CardHeader'

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <DSCardContent ref={ref} className={cn('p-6 pt-0', className)} {...props} />
  )
)
CardContent.displayName = 'CardContent'

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <DSCardFooter ref={ref} className={cn('p-6 pt-0', className)} {...props} />
  )
)
CardFooter.displayName = 'CardFooter'

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
